import React, { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import { Container, Grid, MenuItem, Select } from "@mui/material";

import { useNavigate } from "react-router-dom";

import "./styles.css";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import inviteDriverScheme from "../../../validations/inviteDriverScheme";
import { inviteDriverRequest } from "../../../redux/driver/action";
import { phoneValidationRequest } from "../../../redux/signup/action";
import codeMessage from "../../../services/apiManager/httpMessages";
import CustomLoader from "../../../components/CustomLoader";
import storePersist, { localConstant } from "../../../services/localStorage";
import { useResponsive } from "../../../hooks/useResponsive";
import LableComponent from "../../../components/LableComponent";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../../utils/snackbarConfig";
import NavBar from "../../../NavBar";
import { useTranslation } from "react-i18next";
import { COUNTRY_CODE } from "../../../utils/utils";
import { isMobileDeviceCheck } from "../../../utils";

const InviteDrivers = ({
  enableNav = true,
  isDialog = false,
  resetDialog = () => {},
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const smDown = useResponsive("down", "sm");
  const { t } = useTranslation();

  const { current } = useSelector((state) => state.loginReducer);

  const [inviteDriverForm] = useState({
    email: "",
    name: "",
    phoneNumber: "",
    countryCode: "+1",
  });

  const { isLoading } = useSelector((state) => state.signUpReducer);

  const {
    handleSubmit,
    control,
    setError,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: "all",
    defaultValues: inviteDriverForm,
    resolver: yupResolver(inviteDriverScheme),
  });

  const submitForm = (values, isNavigate = false) => {
    const custId = storePersist.get(localConstant.ENTITY_CUSTOMER_ID);
    values.customerId = current.entity_customer_id
      ? current.entity_customer_id
      : custId;

    const newValues = {
      customerId: values.customerId,
      phone: {
        phoneNumber: values?.phoneNumber,
        intlDialCd: values?.countryCode,
      },
      email: values.email,
      name: values.name,
    };
    if (newValues?.phone?.phoneNumber?.length > 8)
      dispatch(
        phoneValidationRequest(
          newValues?.phone?.phoneNumber,
          newValues?.phone?.intlDialCd,
          {},
          (response) => {
            if (response?.message === codeMessage[400]) {
              setError("phoneNumber", {
                type: "manual",
                message: "Invalid phone number",
              });
            } else {
              dispatch(
                inviteDriverRequest(newValues, (res) => {
                  if (res?.status === "ACCEPTED") {
                    if (isNavigate) {
                      enqueueSnackbar(t("pages.inviteDrivers.text15"), {
                        variant: "success",
                        autoHideDuration: 3000,
                        action: SnackbarConfig,
                      });
                      navigate("/driversList");
                      if (isDialog) {
                        resetDialog();
                        window.location.reload();
                      }
                    } else reset({});
                  } else {
                    if (res?.response?.data?.message) {
                      enqueueSnackbar(res?.response?.data?.message, {
                        variant: "error",
                        autoHideDuration: 3000,
                        action: SnackbarConfig,
                      });
                    }
                  }
                }),
              );
            }
          },
        ),
      );
  };

  const renderInviteDriversForm = (
    <>
      <Stack spacing={2}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        ></Box>
        <form onSubmit={handleSubmit((data) => submitForm(data))}>
          <Stack spacing={2}>
            <Controller
              name="email"
              defaultValue=""
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={
                    <LableComponent
                      customLable={t("pages.inviteDrivers.text01")}
                    />
                  }
                  name="email"
                  type="email"
                  error={!!errors.email}
                  helperText={errors.email?.message}
                />
              )}
            ></Controller>
            <Controller
              name="name"
              defaultValue=""
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  name="name"
                  type="name"
                  label={
                    <LableComponent
                      customLable={t("pages.inviteDrivers.text02")}
                    />
                  }
                  error={!!errors.name}
                  helperText={errors.name?.message}
                />
              )}
            ></Controller>
            <Grid
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
            >
              <Grid>
                <Controller
                  name="countryCode"
                  control={control}
                  render={({ field }) => (
                    <Select
                      renderValue={(value) =>
                        value?.length
                          ? Array.isArray(value)
                            ? value.join(", ")
                            : value
                          : "Country Code"
                      }
                      sx={{
                        width: isMobileDeviceCheck() ? 80 : 100,
                      }}
                      defaultValue={"+1"}
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      autoWidth
                      label="Country Code"
                      {...field}
                    >
                      {Object.keys(COUNTRY_CODE).map((item) => {
                        return (
                          <MenuItem value={item}>{COUNTRY_CODE[item]}</MenuItem>
                        );
                      })}
                    </Select>
                  )}
                ></Controller>
                <p style={{ color: "#d32f2f", fontSize: "12px" }}>
                  {errors.countryCode?.message}
                </p>
              </Grid>
              <Grid width={"80%"}>
                <Controller
                  name="phoneNumber"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      name="phoneNumber"
                      label={
                        <LableComponent
                          customLable={t("pages.inviteDrivers.text03")}
                        />
                      }
                      style={{
                        width: "100%",
                      }}
                      error={!!errors.phoneNumber}
                      helperText={errors.phoneNumber?.message}
                      type="phoneNumber"
                    />
                  )}
                ></Controller>
              </Grid>
            </Grid>
          </Stack>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "center",
            }}
            className="buttons_container"
          >
            <LoadingButton
              sx={{ mt: 5, mb: 5, width: 188 }}
              size="large"
              variant="contained"
              color="inherit"
              disabled={isLoading || !isValid}
              onClick={handleSubmit((data) => submitForm(data, true))}
            >
              + {t("pages.inviteDrivers.text05")}
            </LoadingButton>
          </div>
        </form>
      </Stack>
    </>
  );

  return (
    <Container
      disableGutters
      style={{
        position: "relative",
        minHeight: !isDialog && "100vh",
        width: isDialog ? "100%" : "100vw",
        height: isDialog ? "auto" : "100vh",
      }}
    >
      {enableNav && (
        <NavBar
          title={t("pages.inviteDrivers.pageHeading")}
          enableMenu={false}
        />
      )}
      <Box
        sx={{
          flexGrow: 1,
          height: 1,
          minHeight: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ height: 1, width: 1, padding: 0 }}
        >
          <Card
            sx={{
              p: 3,
              pb: 0,
              width: 1,
              height: smDown ? 1 : "auto",
            }}
            className="form_container"
          >
            {renderInviteDriversForm}
          </Card>
        </Stack>
      </Box>
      {isLoading && <CustomLoader />}
    </Container>
  );
};

export default InviteDrivers;
